import { BundlePrice } from 'components/BundlePrice';
import { Box } from '@mui/material';
import { SpecialOfferProps } from '../types';
import { StyledFabelTownSpecialOffer } from './style';
import React from 'react';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { EBundlesInternalViewModel } from 'utils/enums';

const MAX_PRODUCTS = 5;

export const FabelTownSpecialOffer: React.FC<SpecialOfferProps> = ({
    dataTestId,
    prices,
    productsList,
    availability,
    backgroundImage,
    selectOffer,
    isFree,
    availabilityText = 'Availability',
    collectText = 'Collect',
    specialOfferRef,
    timer,
}) => {
    const availabilityString =
        availability?.remaining && availability?.total
            ? `${availabilityText} ${availability.remaining}/${availability.total}`
            : '';
    const products = (productsList || []).slice(0, MAX_PRODUCTS);
    const imageSize = products.length === 1 ? 72 : 64;

    return (
        <StyledFabelTownSpecialOffer
            backgroundImage={backgroundImage}
            onClick={selectOffer}
            data-testid={dataTestId}
            ref={specialOfferRef}
            imageSize={imageSize}
            products={products}
        >
            <Box className="special-offer__decorative-block">
                <Box className="products-container">
                    {products.map((product, index) => (
                        <Box key={index}>
                            <Box className="image-container">
                                <img
                                    className="image"
                                    src={product.images?.product || ''}
                                    alt="product"
                                />
                            </Box>
                            <Box className="amount-container">
                                <AutoTextSize
                                    mode="oneline"
                                    maxFontSizePx={14}
                                    minFontSizePx={8}
                                    className="main-amount"
                                >
                                    {product.quantityDisplay}
                                </AutoTextSize>
                                {product.strokedSaleQuantity && (
                                    <AutoTextSize
                                        mode="oneline"
                                        maxFontSizePx={10}
                                        className="crossed-amount"
                                    >
                                        {product.strokedSaleQuantity}
                                    </AutoTextSize>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box className={`info-container ${!timer && availabilityString ? 'only-availability' : ''}`}>
                    {timer && <p className="end-text">Ends in {timer}</p>}
                    {availabilityString && <p className="availability-text">{availabilityString}</p>}
                </Box>
            </Box>
            <Box className="price-container">
                <BundlePrice
                    prices={prices}
                    type={EBundlesInternalViewModel.FABEL_TOWN}
                    textShadow="0 0 4px #205BA5"
                    isFree={isFree}
                    buttonText={collectText}
                    isTextAutoResized={true}
                />
            </Box>
        </StyledFabelTownSpecialOffer>
    );
};